var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"text-center"},[_vm._v("I acknowledge the traditional custodians of the land on which I live, work and play, paying respect to their elders and storytellers, past, present and emerging.")])}
var staticRenderFns = []

export { render, staticRenderFns }